import { motion } from "framer-motion";

const PILLARS = [
  { title: "Technology Consulting", body: "Real-world experience solving technology problems for organizations." },
  { title: "Education", body: "Decades teaching youth, adults, professionals, and executives." },
  { title: "Communication", body: "Experience translating complex ideas for audiences ranging from beginners to technical professionals." },
  { title: "Entrepreneurship", body: "Understanding technology from the perspective of business owners and organizational leaders." },
  { title: "Community Impact", body: "A long history of expanding access to technology education." },
];

export default function WhyPhillip() {
  return (
    <section id="why" data-testid="why-phillip-section" className="py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, ease: "easeOut" }} className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-accent">
          Why Phillip
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }} className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-6 max-w-3xl">
          A technologist who knows <span className="italic text-primary">how to teach.</span>
        </motion.h2>
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.15, ease: "easeOut" }} className="mt-8 max-w-2xl space-y-4 text-base sm:text-lg leading-relaxed font-light text-foreground/80">
          <p>There are many technology experts.</p>
          <p>There are many professional trainers.</p>
          <p className="font-medium text-foreground">Phillip has spent more than three decades doing both.</p>
        </motion.div>

        <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.07, ease: "easeOut" }}
              data-testid={`why-pillar-${i}`}
              className="border-t-2 border-primary/40 pt-6"
            >
              <h3 className="font-display text-xl tracking-tight">{p.title}</h3>
              <p className="mt-3 text-sm leading-relaxed font-light text-foreground/70">{p.body}</p>
            </motion.div>
          ))}
        </div>

        <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }} className="mt-16 max-w-3xl font-display text-xl sm:text-2xl text-foreground font-medium">
          That combination allows Phillip to connect technology strategy with the
          people expected to actually use it.
        </motion.p>
      </div>
    </section>
  );
}
